import Container from 'components/Container/Container'
import styled from 'styled-components'
import { themes } from 'theme/styled'

export const CreateClientLabel = styled.h3`
  color: ${themes.Light.colors.primary};
`

export const CreateClientContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`

export const StyledContainer = styled(Container)`
  margin-top: 35px;
  height: 100%;
  padding: 27px 38px;
  border-radius: 39px;
  border: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.05);
`

export const InputGroup = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  & > div {
    width: 48%;
  }
`

export const InfoText = styled.p`
  margin-top: 20px;
`

export const ContentWrapper = styled.div`
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
